<template>
    <v-dialog
      ref="dialog"
      v-model="addPricePeriodDialog"
      persistent
      content-class="pro-dialog"
      width="800px"
      style="z-index:565645454545455">
        <v-card :style="'font-family:' + fontFamily" v-if="currentPricePeriod !== null">
            <v-card-title style="margin-bottom: 20px">
                <span style="font-size: 1.5rem; font-weight: 400" v-if="!isEditMode">Ajout d'une période tarifaire</span>
                <span style="font-size: 1.5rem; font-weight: 400" v-else>Modification d'une période tarifaire</span>
                <v-btn icon class="close-modal-icon" @click="closeDialog()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <div class="d-md-flex justify-start">
                    <div class="mr-5 mb-2">
                        <label>Date de début</label>
                        <v-text-field v-model="dateStartFr" readonly hide-details @click="openPicker('dateStart')"
                                      outlined>
                        </v-text-field>
                    </div>

                    <div class="mr-5 mb-2">
                        <label>Date de fin</label>
                        <v-text-field v-model="dateStopFr" readonly hide-details @click="openPicker('dateStop')"
                                      outlined>
                        </v-text-field>
                    </div>

                    <div>
                        <label>Devise</label>
                        <v-select :items="currencies" v-model="currentPricePeriod.currency" item-text="label"
                                        item-value="code" style="width: 100px;" hide-details return-object outlined>
                        </v-select>
                    </div>
                </div>

                <div class="mb-3">
                    <hr style="margin: 30px 0 25px">

                    <div v-for="(price, i) in currentPricePeriod.prices" class="mt-2 mb-5">
                        <hr v-if="i !== 0" style="margin: 30px 0 25px">
                        <div class="d-md-flex justify-content-between">
                            <div class="mb-5">
                                <div class="d-flex">
                                    <v-autocomplete label="Type de tarif"
                                                    class="price-mode-input"
                                                    :class="{ 'input-error': price.isEmptyElement !== undefined && price.isEmptyElement === true && price.element === null }"
                                                    :items="availablePrices"
                                                    item-text="label"
                                                    v-model="price.element"
                                                    hide-details
                                                    no-data-text="Aucun tarifs disponibles"
                                                    style="width: 270px;padding-top: 0 !important;"
                                                    @change="updateAvailableElements"
                                                    return-object
                                                    outlined>
                                    </v-autocomplete>

                                    <v-btn class="d-md-none" icon @click="deletePricePeriod(i)">
                                        <v-icon color="error"
                                                class="mt-auto mb-auto"
                                                style="height: 40px; width: 40px">delete
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <div class="mb-5">
                                <v-select class="price-mode-input"
                                                label="Mode"
                                                :items="priceModes"
                                                hide-details
                                                v-model="price.mode"
                                                style="width: 150px; padding-top: 0 !important;"
                                                item-text="label"
                                                item-value="code"
                                                outlined>
                                </v-select>
                            </div>
                            <div>
                                <div class="d-flex justify-space-between w-100 price-input-container">
                                    <div class="d-flex mr-2">
                                        <v-text-field v-model="price.min" hide-details :class="{
                                                'input-error': price.isEmptyPrice !== undefined &&
                                                    price.isEmptyPrice === true &&
                                                    price.isEmptyElement !== undefined &&
                                                    price.isEmptyElement === false &&
                                                    (price.min === null || price.min === '') &&
                                                    (price.max === null || price.max === '') &&
                                                    (price.detail === null || price.detail === '')
                                            }" type="number" style="padding-top: 0 !important; width: 100px" :min="0" outlined>
                                            <template v-slot:append>
                                                <div class="currency mt-auto mb-auto" style="font-size: 20px">
                                                    {{ currentPricePeriod.currency.label }}
                                                </div>
                                            </template>
                                        </v-text-field>
                                    </div>

                                    <div class="d-flex ml-2" v-if="price.mode === 'MIN_MAX'">
                                        <v-text-field v-model="price.max" hide-details :class="{
                                                'input-error': price.isEmptyPrice !== undefined &&
                                                    price.isEmptyPrice === true &&
                                                    price.isEmptyElement !== undefined &&
                                                    price.isEmptyElement === false &&
                                                    (price.min === null || price.min === '') &&
                                                    (price.max === null || price.max === '') &&
                                                    (price.detail === null || price.detail === '')
                                            }" type="number" style="padding-top: 0 !important; width: 100px" :min="0" outlined>
                                            <template v-slot:append>
                                                <div class="currency mt-auto mb-auto" style="font-size: 20px">
                                                    {{ currentPricePeriod.currency.label }}
                                                </div>
                                            </template>
                                        </v-text-field>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="d-none d-md-flex">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" icon @click="deletePricePeriod(i)">
                                                <v-icon color="gray" class="mt-auto mb-auto" large
                                                        style="height: 40px; width: 40px">close
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <div>Supprimer</div>
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>

                        <div class="mt-4" v-if="price.isEmptyElement !== undefined &&
                            price.isEmptyElement === true &&
                            price.element === null">
                            <v-alert color="error" style="color: white">Le type de tarif doit être renseigné
                            </v-alert>
                        </div>

                        <div class="mt-4" v-else-if="price.isEmptyElement !== undefined &&
                            price.isEmptyElement === false &&
                            price.isEmptyPrice !== undefined &&
                            price.isEmptyPrice === true &&
                            (price.min === null || price.min === '') &&
                            (price.max === null || price.max === '') &&
                            (price.detail === null || price.detail === '')">
                            <v-alert color="error" style="color: white">Le tarif ou la précision tarifaire doit être
                                renseigné</v-alert>
                        </div>

                        <div>
                            <v-textarea class="textarea mt-5" label="Précisions" height="70px" hide-details :class="{
                                    'input-error': price.isEmptyPrice !== undefined &&
                                        price.isEmptyPrice === true &&
                                        price.isEmptyElement !== undefined &&
                                        price.isEmptyElement === false &&
                                        (price.min === null || price.min === '') &&
                                        (price.max === null || price.max === '') &&
                                        (price.detail === null || price.detail === '')
                                }" v-model="price.detail" outlined>
                            </v-textarea>
                        </div>
                    </div>

                    <v-btn text :color="primaryColor" class="text-none" @click="addPrice"
                           style="padding-left: 0; font-size: 19px">
                        <v-icon class="mr-2" style="font-size: 30px">add</v-icon> Ajouter un tarif
                    </v-btn>
                </div>

                <v-alert type="error" v-if="message !== null">
                    {{ message }}
                </v-alert>
            </v-card-text>

            <v-card-actions>
                <div class="w-100 text-center">
                    <v-btn class="text-none mb-4" v-if="!isEditMode" :color="primaryColor" @click="saveDate"
                           :disabled="message !== null || dateStop === null || dateStart == null"
                           style="border-radius: 20px; color: white">
                        <v-icon class="mr-2">add</v-icon>Ajouter
                    </v-btn>

                    <v-btn class="text-none mb-4" v-else @click="updatePeriod" :color="primaryColor"
                           :disabled="message !== null || dateStop === null || dateStart == null"
                           style="border-radius: 20px; color: white">
                        Enregistrer
                    </v-btn>
                </div>
            </v-card-actions>
        </v-card>

        <v-dialog
            ref="dialog"
            v-model="showPicker"
            persistent
            width="290px">
            <v-date-picker
                locale="fr-FR"
                color="primary"
                v-model="selectedDate"
                @input="setDatePicker"
                :first-day-of-week="1">
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="showPicker = false">Annuler</v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="showPicker = false">Valider</v-btn>
            </v-date-picker>
        </v-dialog>
    </v-dialog>
</template>

<script>
import {mapMutations, mapState} from "vuex"
import da from "element-ui/src/locale/lang/da"

export default {
    name: "AddPeriodModal",
    props: ['availableElements'],
    data() {
        return {
            dateStart: null,
            dateStop: null,
            selectedDateProperty: null,
            selectedDate: null,
            showPicker: false,
            priceModes: [
                { code: 'MIN_MAX', label: 'Min / max' },
                { code: 'UNIQUE', label: 'Tarif unique' },
                { code: 'FROM', label: 'À partir de' }
            ],
        }
    },
    methods: {
        ...mapMutations('web_form', ['setAddPricePeriodDialog', 'setCurrentPricePeriod', 'setPricesTabDirty',]),
        openPicker(property) {
            this.selectedDateProperty = property
            this.showPicker = true
        },
        closeDialog() {
            this.setCurrentPricePeriod(null)
            this.setAddPricePeriodDialog(false)

            this.dateStart = null
            this.dateStop = null
        },
        updateAvailableElements() {
            let prices = JSON.parse(JSON.stringify(this.currentPricePeriod.prices)).map(price => price.element)

            this.availablePrices.map(element => {
                element.disabled = false

                prices.filter(price => {
                    if (price !== null && price.id === element.id) {
                        element.disabled = true
                    }
                })
            })
        },
        deletePricePeriod(index) {
            this.currentPricePeriod.prices.splice(index, 1)

            this.$forceUpdate()

            this.updateAvailableElements()
        },
        addPrice() {
            let mode = this.priceModes[2].code

            if (this.currentPricePeriod.prices.length) {
                mode = this.currentPricePeriod.prices[this.currentPricePeriod.prices.length - 1].mode
            }

            this.currentPricePeriod.prices.push({ min: null, max: null, element: null, mode: mode, detail: null })
        },
        saveDate() {
            let hasEmptyElements = false

            this.currentPricePeriod.prices.forEach(price => {
                this.$set(price, 'isEmptyElement', false)
                this.$set(price, 'isEmptyPrice', false)

                if (price.element === null) {
                    hasEmptyElements = true

                    price.isEmptyElement = true
                }

                if ((price.min === null || price.min === '') &&
                    (price.max === null || price.max === '') &&
                    (price.detail === null || price.detail === '')) {

                    hasEmptyElements = true

                    price.isEmptyPrice = true
                }
            })

            if (!hasEmptyElements) {
                this.addPeriod()
                this.setPricesTabDirty(true)
                this.setAddPricePeriodDialog(false)
            }
        },
        addPeriod() {
            let period = this.currentPricePeriod

            period.valid_from = this.dateStart
            period.valid_through = this.dateStop

            this.provider.price_periods.push(period)
        },
        updatePeriod() {
            let hasEmptyElements = false

            this.currentPricePeriod.prices.forEach(price => {
                this.$set(price, 'isEmptyElement', false)
                this.$set(price, 'isEmptyPrice', false)

                if (price.element === null) {
                    hasEmptyElements = true

                    price.isEmptyElement = true
                }

                if ((price.min === null || price.min === '') &&
                    (price.max === null || price.max === '') &&
                    (price.detail === null || price.detail === '')) {

                    hasEmptyElements = true

                    price.isEmptyPrice = true
                }
            })

            if (!hasEmptyElements) {
                this.currentPricePeriod.valid_from = this.dateStart
                this.currentPricePeriod.valid_through = this.dateStop

                this.provider.price_periods.forEach((period, index) => {
                    if (period.uid === this.currentPricePeriod.uid) {
                        this.$set(this.provider.price_periods, index, this.currentPricePeriod)
                    }
                })

                this.setPricesTabDirty(true)
                this.setAddPricePeriodDialog(false)
            }
        },
        setDatePicker(value) {
            this[this.selectedDateProperty] = value
        },
    },
    watch: {
        currentPricePeriod() {
            if (this.currentPricePeriod !== null) {
                this.dateStart = this.currentPricePeriod.valid_from
                this.dateStop = this.currentPricePeriod.valid_through

                this.availableElements.forEach(element => {
                    const exist = this.currentPricePeriod.prices.find(price => price.element.id === element.id)

                    element.disabled = !!exist;
                })
            }
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'addPricePeriodDialog', 'currentPricePeriod', 'accountTisType']),
        ...mapState('resource', ['currencies']),
        ...mapState("webFormStyle", ["fontFamily", 'primaryColor']),
        ...mapState("forbiddenCriteria", ["forbiddenCriteria"]),
        isEditMode() {
            if (this.currentPricePeriod === null) {
                return false
            }

            return this.provider.price_periods.find(period => period.valid_from === this.currentPricePeriod.valid_from) !== undefined
        },
        da() {
            return da
        },
        dateStartFr() {
            if (!this.dateStart) {
                return null
            }

            return this.$moment(this.dateStart).format("DD/MM/YYYY")
        },
        dateStopFr() {
            if (!this.dateStop) {
                return null
            }

            return this.$moment(this.dateStop).format("DD/MM/YYYY")
        },
        message() {
            let message = null

            if (this.dateStart > this.dateStop) {
                message = "La date de début doit précéder la date de fin"
            }

            this.provider.price_periods.forEach((period) => {
                if (
                    period.uid !== this.currentPricePeriod.uid &&
                    ((this.dateStart >= period.valid_from && this.dateStart <= period.valid_through) ||
                        (this.dateStop >= period.valid_from && this.dateStop <= period.valid_through))
                ) {
                    message = "La période que vous créez actuellement recouvre une autre période"
                }
            })

            return message
        },
        availablePrices() {
            if(this.accountTisType === 'DAHUB_QUEBEC') {
                return this.availableElements
            } else {
                let forbiddenBy = []

                // parcours des tarifs disponibles pour la catégorie (périmètre max)
                this.availableElements.forEach(element => {
                    let criteria = this.forbiddenCriteria.find(criteria => criteria.id === element.apidae_element_id)

                    // recup des éléments interdits pour ce tarif
                    if (criteria && criteria.forbiddenBy) {
                        // recup de la liste des éléments déjà sélectionnés, qui sont interdits pour ce tarif
                        const filteredElements = this.provider.elements.filter(_element => {
                            return criteria.forbiddenBy.includes(_element.apidae_element_id)
                        })

                        // si aucun élément interdit, le tarif est disponible
                        if (!filteredElements.length) {
                            forbiddenBy.push(element)
                        }
                    }
                })

                let forbiddenFor = []

                this.provider.elements.forEach(element => {
                    let criteria = this.forbiddenCriteria.find(criteria => criteria.id === element.apidae_element_id)

                    // recup des éléments interdits pour ce tarif
                    if (criteria && criteria.forbiddenFor) {
                        // recup de la liste des éléments déjà sélectionnés, qui sont interdits pour ce tarif
                        const filteredElements = this.availableElements.filter(_element => {
                            return criteria.forbiddenFor.includes(_element.apidae_element_id)
                        })

                        // si aucun élément interdit, le tarif est disponible
                        if (!filteredElements.length) {
                            forbiddenFor.push(element)
                        }
                    }
                })

                return forbiddenBy.filter(element => !forbiddenFor.some(_elt => _elt.id === element.id))
            }
        }
    }
}
</script>